import { Component, OnInit } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { PermissionsService } from 'src/app/core/services/permissions.service';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { CustomerPortal } from 'src/app/features/secured-skeleton/models/customer-portal';
import { ManagedServicesRepository } from '../../services/managed-services-repository.service';
import { IManagedServicesPortalSection } from '../../models/msp-portal';

@Component({
  selector: 'portals',
  templateUrl: './portals.component.html',
  styleUrls: ['./portals.component.scss'],
  standalone: false,
})
export class PortalsComponent implements OnInit {
  // Stores info about the portal trying to be accessed
  portal: CustomerPortal;

  // // Stores the home section to be showed Portal header
  // homeSection: Partial<IManagedServicePortal>;

  // Stores sections to be showed under the MSP - Management and Reporting Portals header
  mspPortals: IManagedServicesPortalSection[] = [];

  /** True if the component is loading data */
  isLoading: boolean = false;

  // True if the user is global admin
  get isAdminUser(): boolean {
    return this.permissionsService.hasCompanyAdminPermissions();
  }

  constructor(
    private userDataService: UserDataService,
    private managedServicesRepository: ManagedServicesRepository,
    private permissionsService: PermissionsService,
  ) {}

  ngOnInit(): void {
    this.fetchMspPortals();
  }

  fetchMspPortals() {
    this.isLoading = true;
    this.fetchMspData(this.managedServicesRepository.getMspAccountPortals(this.userDataService.company.id), (data) => {
      this.mspPortals = data;
    });
  }

  private fetchMspData<T>(
    request: Observable<T>,
    onSuccess?: (response: T) => void,
    onError?: (err: any) => void,
    onFinalize?: () => void,
  ) {
    request
      .pipe(
        finalize(() => {
          if (onFinalize !== undefined) {
            onFinalize();
          }
          this.isLoading = false;
        }),
      )
      .subscribe({
        next: (res) => {
          if (onSuccess !== undefined) {
            onSuccess(res);
          }
        },
        error: (err) => {
          console.error('Error:', err);
          if (onError !== undefined) {
            onError(err);
          }
        },
      });
  }

  validateExternalSection(uri: string): boolean {
    return uri.includes('https') || uri.includes('http');
  }

  openSection(url: string): void {
    if (this.validateExternalSection(url)) {
      window.open(url, '_blank');
    }
  }
}
